import { useEffect, useRef } from "react";

interface UseIntersectionObserverOptions {
  threshold?: number;
  rootMargin?: string;
  selector?: string;
}

export const useIntersectionObserver = (
  options: UseIntersectionObserverOptions = {}
) => {
  const {
    threshold = 0.1,
    rootMargin = "0px",
    selector = ".fade-up-section",
  } = options;
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold, rootMargin }
    );

    const section = sectionRef.current;
    if (section) {
      const elements = section.querySelectorAll(selector);
      elements.forEach((element) => observer.observe(element));
    }

    return () => {
      if (section) {
        const elements = section.querySelectorAll(selector);
        elements.forEach((element) => observer.unobserve(element));
      }
    };
  }, [threshold, rootMargin, selector]);

  return sectionRef;
};
